import { render, staticRenderFns } from "./NewConversationSetupPage.vue?vue&type=template&id=0ee5cbe4&scoped=true"
import script from "./NewConversationSetupPage.vue?vue&type=script&lang=js"
export * from "./NewConversationSetupPage.vue?vue&type=script&lang=js"
import style0 from "./NewConversationSetupPage.vue?vue&type=style&index=0&id=0ee5cbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5cbe4",
  null
  
)

export default component.exports